import Vue from "vue";
import VueMeta from "vue-meta";
import VueRouter from "vue-router";

import store from "@/store/store";
import routes from "./routes";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: "page",
});

const router = new VueRouter({
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active mm-active",
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
const isLayoutChanged = (routeFrom, routeTo) => {
  const from = routeFrom.path.split("/")[1];
  const to = routeTo.path.split("/")[1];
  return from != to;
};

router.beforeEach((routeTo, routeFrom, next) => {
  store.dispatch("requestQueue/abortAll");

  if (isLayoutChanged(routeFrom, routeTo)) {
    // store.commit("organizationPolicy/resetFilters");
  }

  const meta = routeTo.meta;
  const rules = meta && meta.rules;

  if (rules) {
    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i](routeTo, routeFrom);

      let isChecked = rule.rule(routeTo, routeFrom);

      if (!isChecked) {
        if (rule.redirect == -1) {
          next(routeFrom.path);
        } else {
          next(rule.redirect ?? "/403");
        }
        return;
      }
    }
  }

  next();
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  let product;

  if (routeTo.path.startsWith("/fwsed")) {
    product = "FWSED";
  } else if (routeTo.path.startsWith("/organization")) {
    product = "PLATFORM";
  } else {
    product = undefined;
  }

  store.dispatch("product/setCurrentProduct", product);
  next();
});

export default router;
